/**
 * Constant cấp
 * ndhieu3 19.04.2023
 */
export default {
  Province: 1, // Tỉnh/Thành phố
  District: 2, // Quận/Huyện
  Ward: 3, // Xã/Phường
};
